import { BaseAction } from '../../store/actions';
import { InsightsData, InsightsParams } from '../../shared/models/insights';

export enum InsightsActions {
  LoadInsights = '[Insights] Load Insights',
  LoadInsightsSuccess = '[Insights] Load Insights Success',
  LoadInsightsError = '[Insights] Load Insights Error',
  UpdateInsightsFilter = '[Insights] Update Filter',
}

export class LoadInsights implements BaseAction<InsightsActions> {
  readonly type = InsightsActions.LoadInsights;

  constructor(public readonly params: InsightsParams) {}
}

export class LoadInsightsSuccess implements BaseAction<InsightsActions> {
  readonly type = InsightsActions.LoadInsightsSuccess;

  constructor(public readonly payload: InsightsData) {}
}

export class LoadInsightsError implements BaseAction<InsightsActions> {
  readonly type = InsightsActions.LoadInsightsError;

  constructor(public readonly payload: string) {}
}

export class UpdateInsightsFilter implements BaseAction<InsightsActions> {
  readonly type = InsightsActions.UpdateInsightsFilter;

  constructor(public readonly payload: InsightsParams) {}
}


export type InsightsAction = LoadInsights | LoadInsightsSuccess | LoadInsightsError | UpdateInsightsFilter;
